module.exports = __webpack_public_path__ + "static/media/blinds-open.bc310217.svg";